import React, { useState } from "react";
import TextInput from "../../../components/elements/forms/TextInput";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import SubmitButton from "../../../components/elements/forms/SubmitButton";
import img from "../../../constant";
import { iResetPassword, iResetPasswordError } from "../../../store/types/auth";
import { reset_password } from "../../../services/api/auth";
import { useAppDispatch } from "../../../store/hooks";
import { get_cookie } from "../../../config/cookie";

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const [show, showSet] = React.useState<"password" | "text">("password");
  const [showConfirm, showConfirmSet] = React.useState<"password" | "text">("password");
  const [loading, setLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [data, dataSet] = React.useState<iResetPassword>({
    encoded: "",
    newPassword: "",
  });
  const [error, errorSet] = React.useState<iResetPasswordError>({
    encoded: "",
    newPassword: "",
  });

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
    errorSet((prev) => ({ ...prev, [name]: "" }));
  };

  const onConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(e.target.value);
    setConfirmPasswordError("");
  };

  const onSubmitHandler = async () => {
    let validate: boolean = false;
    
    if (!data.newPassword) {
      validate = true;
      errorSet((prev) => ({ ...prev, newPassword: "warning" }));
    }
    
    if (!confirmPassword) {
      validate = true;
      setConfirmPasswordError("warning");
    }
    
    // Validate password match
    if (data.newPassword && confirmPassword && data.newPassword !== confirmPassword) {
      validate = true;
      setConfirmPasswordError("warning");
      errorSet((prev) => ({ ...prev, newPassword: "warning" }));
    }
    
    if (validate) return;
    setLoading(true);
    const success = await reset_password(data, dispatch);
    if (success) {
      navigate("/login");
    }
    setLoading(false);
  };

  const onLoad = React.useCallback(() => {
    if (get_cookie("@serial")) navigate("/dashboard");
    
    // Extract encoded from URL query parameter
    const encodedFromUrl = searchParams.get("encoded") || searchParams.get("token") || "";
    if (encodedFromUrl) {
      dataSet((prev) => ({ ...prev, encoded: encodedFromUrl }));
    }
  }, [navigate, searchParams]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="font-abel bg-[#D9ECFF] h-screen">
      <div className="grid md:grid-cols-2 gap-0 md:items-center h-full">
        <div className="col-span-1 h-full hidden md:block">
          <div className="bg-bgLogin bg-cover bg-center h-full">
            <div className="h-full w-full max-w-[588px] mx-auto text-white text-left flex flex-col items-left justify-evenly">
              <Link to={`/`}>
                <img
                  src={img.logoWhite}
                  alt="logo"
                  className="md:w-[100px] w-[65px]"
                />
              </Link>
              <h1 className="text-3xl md:text-[100px] md:leading-[98.2%]">
                AI Recruiter
              </h1>
              <div></div>
            </div>
          </div>
        </div>
        <div className="col-span-1 w-full h-full border-none rounded-lg px-4 md:px-0 py-10 md:py-20">
          <div className="h-[100%] w-full max-w-[650px] bg-[white] py-4 px-4 flex justify-center items-center md:rounded-tr-[20px] md:rounded-br-[20px] md:rounded-[30px] rounded-10">
            <div className="w-[100%] max-w-[500px]">
              <div className="text-center w-full mb-4">
                <div className="flex items-center justify-center mb-5 md:hidden">
                  <Link to={`/home`}>
                    <img
                      src={img.logo}
                      alt="logo"
                      className="md:w-[130px] w-[75px]"
                    />
                  </Link>
                </div>
                <h3 className="md:text-[50px] text-[32px]">Reset Password</h3>
              </div>
              <div>
                <TextInput
                  label="NEW PASSWORD"
                  placeholder="Enter New Password"
                  name="newPassword"
                  type={show}
                  status={error.newPassword}
                  value={data.newPassword}
                  onChange={onChangeHandler}
                  container="mb-3"
                  right_icon={
                    show === "text" ? (
                      <FaRegEyeSlash
                        size={20}
                        className="cursor-pointer"
                        onClick={() => showSet("password")}
                        color="#667185"
                      />
                    ) : (
                      <FaRegEye
                        size={20}
                        className="cursor-pointer"
                        onClick={() => showSet("text")}
                        color="#667185"
                      />
                    )
                  }
                />
                <TextInput
                  label="CONFIRM PASSWORD"
                  placeholder="Confirm New Password"
                  name="confirmPassword"
                  type={showConfirm}
                  status={confirmPasswordError}
                  value={confirmPassword}
                  onChange={onConfirmPasswordChange}
                  container="mb-3"
                  right_icon={
                    showConfirm === "text" ? (
                      <FaRegEyeSlash
                        size={20}
                        className="cursor-pointer"
                        onClick={() => showConfirmSet("password")}
                        color="#667185"
                      />
                    ) : (
                      <FaRegEye
                        size={20}
                        className="cursor-pointer"
                        onClick={() => showConfirmSet("text")}
                        color="#667185"
                      />
                    )
                  }
                />
                {data.newPassword && confirmPassword && data.newPassword !== confirmPassword && (
                  <p className="text-red-500 text-sm mb-3">Passwords do not match</p>
                )}
                <div className="flex justify-end items-center my-5 align-center">
                  <Link to="/login" className="text-secondary text-[14px]">
                    Back to Login
                  </Link>
                </div>
                <div className="w-[100%]">
                  <SubmitButton
                    title="Submit"
                    onSubmitHandler={onSubmitHandler}
                    loading={loading}
                    className="font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
